import { computed, inject, Injectable, signal } from '@angular/core';
import { I18n, I18nHelper } from '@core/i18n';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class I18nService {
    private translateService = inject(TranslateService);

    private readonly _lang = signal<I18n>(I18n.EN);
    readonly lang = computed(() => this._lang());

    initialize(): void {
        this.setLanguage(I18nHelper.initialize());
    }

    setLanguage(lang: I18n) {
        this.translateService.use(lang).subscribe({
            next: () => {
                const sub = this.translateService.onLangChange.subscribe(event => {
                    if (!event.translations || Object.keys(event.translations).length === 0) {
                        this.retryLanguage(lang);
                    }

                    sub.unsubscribe();
                });
            },
            error: err => {
                console.error(`[I18n] Failed to load "${lang}". Retrying...`, err);
                this.retryLanguage(lang);
            },
        });

        this._lang.set(lang);
        localStorage.setItem(I18nHelper.STORAGE_KEY, lang);
    }

    private retryLanguage(lang: I18n) {
        this.translateService.reloadLang(lang).subscribe({
            next: () => console.warn(`[I18n] Successfully reloaded "${lang}".`),
            error: err => console.error(`[I18n] Retry failed for "${lang}".`, err),
        });
    }
}
